import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { loadApplications } from "../../../queries/consumer/application";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ApplicationBox from "../applications/ApplicationBox";
import {
  getFincludeTotalApps,
  getFinstreamTotalApps,
} from "../../../queries/metrics";
import {
  loadOrganization,
  updateOrganization,
} from "../../../queries/organization";
import isEmpty from "lodash/isEmpty";
import TotalApiCallBarChart from "../applications/TotalApiCallBarChart";
import SuccessRateBarChart from "../applications/SuccessRateBarChart";

const Fragment = React.Fragment;

const DashboardPage = ({ cableApp, currentUser }) => {
  const [alertDismissed, setAlertDismissed] = useState("false");
  const [activeSelect, setActiveSelect] = useState(null);

  const {
    isLoading,
    isError,
    data: applications,
  } = useQuery(
    "applications",
    async () =>
      await loadApplications().then((data) => {
        return data.results;
      })
  );

  const {
    isLoading: isLoadingFincludeApps,
    isError: isErrorFincludeApps,
    data: fincludeTotalApps,
  } = useQuery("finclude_total_apps", async () => await getFincludeTotalApps());

  const {
    isLoading: isLoadingFinstreamApps,
    isError: isErrorFinstreamApps,
    data: finstreamTotalApps,
  } = useQuery(
    "finstream_total_apps",
    async () => await getFinstreamTotalApps()
  );

  const {
    isLoading: isLoadingFinstreamUploads,
    isError: isErrorFinstreamUploads,
    data: finstreamTotalUploads,
  } = useQuery(
    "getFinstreamTotalUploads",
    async () => await getFinstreamTotalApps()
  );

  const {
    isLoading: isLoadingOrganization,
    isError: isErrorOrganization,
    data: organization,
  } = useQuery(
    "organization",
    async () =>
      await loadOrganization(currentUser.organization.id, true)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log(error);
        })
  );

  useEffect(() => {
    setAlertDismissed(localStorage.getItem("upgradeAlertDismissed"));
  }, []);

  const handleUpgradeAccountAlert = () => {
    if (alertDismissed === "true") {
      localStorage.setItem("upgradeAlertDismissed", "false");
      setAlertDismissed("false");
    } else {
      localStorage.setItem("upgradeAlertDismissed", "true");
      setAlertDismissed("true");
    }
  };

  // const handleSelect = (e) => {
  //   if (e.target.id !== activeSelect.id) {
  //     e.target.classList.add("active");
  //     activeSelect.classList.remove("active");
  //     setActiveSelect(e.target);
  //   } else {
  //     e.target.classList.add("active");
  //     setActiveSelect(e.target);
  //   }
  // };

  // useEffect(() => {
  //   let element = document.getElementById("*");
  //   element.classList.add("active");
  //   setActiveSelect(element);
  // }, []);

  return (
    <div className="container">
      {alertDismissed === "false" && currentUser.type === "Admin" && (
        <div
          className="alert bg-main alert-dismissable pr-sm-3 mb-5"
          role="alert"
        >
          <div className="d-flex flex-column flex-md-row align-items-sm-center">
            <div className="pr-sm-3">
              <h5 className="mb-3 mb-sm-2">
                <strong>Upgrade your account</strong>
              </h5>
              <strong>Hello {currentUser.firstName}!</strong> You are currently
              experimenting with our <strong>Free</strong> account that uses
              mock bank data. To get access to all our live platforms and gain
              access to our production scoring upgrade your account!
            </div>
            <Link
              to="/upgrade"
              className="btn btn-main-dark mr-0 mr-sm-auto ml-md-auto mt-3 mt-md-0 nowrap"
            >
              Upgrade account
            </Link>
            <a
              className="btn-close"
              onClick={() => handleUpgradeAccountAlert()}
            >
              &times;
            </a>
          </div>
        </div>
      )}
      <h3 className="mb-4">Dashboard</h3>
      {/* <h3 className="mb-4">{currentUser.organization.id}</h3> */}
{/* 
      <div className="d-flex align-items-end flex-wrap ml-n3">
        <div className="px-3 mb-3">
          <label className="label-sm">FINCLUDE APPS</label>
          <div className="text-xlg text-center">
            <strong>{fincludeTotalApps}</strong>
          </div>
        </div>
        <div className="px-3 mb-3">
          <label className="label-sm">FINSTREAM APPS</label>
          <div className="text-xlg text-center">
            <strong>{finstreamTotalApps}</strong>
          </div>
        </div>
        <div className="px-3 mb-3">
          <label className="label-sm">FINSCORE UPLOADS</label>
          <div className="text-xlg text-center">
            <strong>{finstreamTotalUploads}</strong>
          </div>
        </div>
      </div> */}

      {/* <p>{currentUser.organization.iframe_url}</p> */}

      {/* {!isEmpty(organization) &&
        !isLoadingOrganization &&
        !isErrorOrganization && (
        <iframe
          src={organization.iframeUrl}
          frameBorder="0"
          width={'100%'}
          height="800"
          allowtransparency
        ></iframe>
        )} */}
      {/* <script src="http://metabase.example.com/app/iframeResizer.js"></script> */}
      {!isEmpty(organization) &&
        !isLoadingOrganization &&
        !isErrorOrganization && (
        <iframe 
          src={organization.iframeUrl} 
          onLoad="iFrameResize({}, this)"
          frameBorder="0"
          width={'100%'}
          height={2000}
          allowtransparency
        ></iframe>
        // <IframeResizer
        //   // forwardRef={iframeRef}
        //   heightCalculationMethod="lowestElement"
        //   inPageLinks
        //   log
        //   frameBorder="0"
        //   allowtransparency
        //   // onMessage={onMessage}
        //   // onResized={onResized}
        //   src={organization.iframeUrl}
        //   style={{ width: '1px', minWidth: '100%' }}
        //   height="1200"
        // />
        )}

      


      {/* <div className="row mt-5">
        <div className="col-12 col-lg-6 col-xl-5 mb-5">
          <h6 className="mb-4">Total API Calls</h6>
          <TotalApiCallBarChart cableApp={cableApp} />
        </div>
        <div className="col-12 col-lg-6 col-xl-5 mb-5">
          <div className="mb-4 d-flex">
            <h6 className="mb-0">Success Rate</h6>
            <div className="dropdown ml-auto">
              <a
                className="dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                All services
              </a>
              <ul
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <a
                    className="dropdown-item"
                    id="*"
                    href="#"
                    onClick={(e) => handleSelect(e)}
                  >
                    All Services
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    id="finstreamds"
                    href="#"
                    onClick={(e) => handleSelect(e)}
                  >
                    FinstreamDS
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    id="finstreamvf"
                    href="#"
                    onClick={(e) => handleSelect(e)}
                  >
                    FinstreamVF
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    id="finscorefs"
                    href="#"
                    onClick={(e) => handleSelect(e)}
                  >
                    FinscoreFS
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    id="finscoreqs"
                    href="#"
                    onClick={(e) => handleSelect(e)}
                  >
                    FinscoreQS
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <SuccessRateBarChart cableApp={cableApp} service={activeSelect} />
        </div>
      </div> */}

      {/* <h4 className="mt-5 mb-4">Apps Overview</h4>

      <div className="row">
        {!isEmpty(applications) && !isLoading && !isError && (
          <>
            {applications.map((application) => (
              <Fragment key={application.id}>
                <ApplicationBox
                  key={application.id}
                  application={application}
                  cableApp={cableApp}
                />
              </Fragment>
            ))}
          </>
        )}
      </div> */}

      {/*<?php /**/}
      {/*  <table class="table-list mt-5">*/}
      {/*    <thead>*/}
      {/*      <tr>*/}
      {/*        <th>APP NAME / SUBSCRIBED APIs</th>*/}
      {/*        <th class="text-lg-center">REMAINING API CALLS</th>*/}
      {/*        <th></th>*/}
      {/*      </tr>*/}
      {/*    </thead>*/}
      {/*    <tbody>*/}
      {/*      <tr>*/}
      {/*        <td>*/}
      {/*          <h5 class="mb-1"><a href="app-show.php">Finstream test app 1</a></h5>*/}
      {/*          <p class="mb-2"><small><span class="text-faint">Owner:</span> Nick Sotiriadis</small></p>*/}
      {/*        </td>*/}
      {/*        <td class="text-lg-center">*/}
      {/*          <div class="d-flex justify-content-lg-center">*/}
      {/*            <div class="pr-2">*/}
      {/*              <code class="text-body">finstreamvf</code>*/}
      {/*              <span class="d-block"><span class="text-success">44</span>/50</span>*/}
      {/*            </div>*/}
      {/*            <div class="pr-2">*/}
      {/*              <code class="text-body">finstreamqs</code>*/}
      {/*              <span class="d-block"><span class="text-error">12</span>/50</span>*/}
      {/*            </div>*/}
      {/*          </div>*/}
      {/*        </td>*/}
      {/*        <td class="table-actions">*/}
      {/*          <a class="btn-transparent ml-n2 ml-md-0" href="app-show.php">View</a>*/}
      {/*        </td>*/}
      {/*      </tr>*/}
      {/*    </tbody>*/}
      {/*  </table>*/}
    </div>
  );
};

DashboardPage.propTypes = {
  currentUser: PropTypes.object.isRequired,
  cableApp: PropTypes.object.isRequired,
};

export default DashboardPage;
